import { Promise } from 'es6-promise'
import commonRequest from 'Api/index'
import { currentEntityId } from 'utils/functionUtils'

// state
const state = {
  advertisementInfoList: []
}

// getters
const getters = {
  LIST_ADVERTISEMENT_INFO_DATA: state => {
    return state.advertisementInfoList
  }
}

// actions
const actions = {
  GET_LIST_ADVERTISEMENT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.getRequest(
        process.env.VUE_APP_BACKEND_PROD_URL,
        `/api/v1/portal/${currentEntityId()}/advertisement/`,
        payload,
        function (res) {
          context.commit('GET_LIST_ADVERTISEMENT_INFO_HANDLER', res.data)
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  },
  ADD_ADVERTISEMENT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.postRequest(
        process.env.VUE_APP_BACKEND_PROD_URL,
        `/api/v1/portal/${currentEntityId()}/advertisement/`,
        payload,
        function (res) {
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  },
  DELETE_ADVERTISEMENT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.deleteRequest(
        process.env.VUE_APP_BACKEND_PROD_URL,
        `/api/v1/portal/${currentEntityId()}/advertisement/${payload.id}/`,
        payload,
        function (res) {
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  },
  UPDATE_ADVERTISEMENT_INFO: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.putRequest(
        process.env.VUE_APP_BACKEND_PROD_URL,
        `/api/v1/portal/${currentEntityId()}/advertisement/${payload.id}/`,
        payload,
        function (res) {
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  },
  GET_ADVERTISEMENT_INFO_DETAIL: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.getRequest(
        process.env.VUE_APP_BACKEND_PROD_URL,
        `/api/v1/portal/${currentEntityId()}/advertisement/${payload.id}/`,
        payload,
        function (res) {
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  },
  PUBLIC_BANNER: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.postRequest(
        process.env.VUE_APP_BACKEND_PROD_URL,
        `/api/v1/portal/${currentEntityId()}/advertisement/public_banner/`,
        payload,
        function (res) {
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  },
  TO_DO_INACTIVE_BANNER: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.postRequest(
        process.env.VUE_APP_BACKEND_PROD_URL,
        `/api/v1/portal/${currentEntityId()}/advertisement/inactive_banner/`,
        payload,
        function (res) {
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  }
}

// mutations
const mutations = {
  GET_LIST_ADVERTISEMENT_INFO_HANDLER: (state, payload) => {
    let advertisementInfoList = payload.results
    let page = {
      totalPage: payload.num_pages,
      currentPage: payload.page,
      pageSize: payload.page_size,
      perPage: payload.per_page
    }
    state.advertisementInfoList = payload.results ? { results: advertisementInfoList, paginate: page } : payload.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
